"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ACCESS_TOKEN", {
  enumerable: true,
  get: function get() {
    return _tokens.ACCESS_TOKEN;
  }
});
Object.defineProperty(exports, "ApolloProvider", {
  enumerable: true,
  get: function get() {
    return _ApolloProvider["default"];
  }
});
Object.defineProperty(exports, "ConnectionStatus", {
  enumerable: true,
  get: function get() {
    return _ConnectionStatus["default"];
  }
});
Object.defineProperty(exports, "REFRESH_TOKEN", {
  enumerable: true,
  get: function get() {
    return _tokens.REFRESH_TOKEN;
  }
});
Object.defineProperty(exports, "TokenFetchLink", {
  enumerable: true,
  get: function get() {
    return _TokenFetchLink["default"];
  }
});
Object.defineProperty(exports, "accessTokenFetchingLink", {
  enumerable: true,
  get: function get() {
    return _clientLinks.accessTokenFetchingLink;
  }
});
Object.defineProperty(exports, "accessTokenRequiringLink", {
  enumerable: true,
  get: function get() {
    return _clientLinks.accessTokenRequiringLink;
  }
});
Object.defineProperty(exports, "authTypes", {
  enumerable: true,
  get: function get() {
    return _authType.authTypes;
  }
});
Object.defineProperty(exports, "clearLocalToken", {
  enumerable: true,
  get: function get() {
    return _core.clearLocalToken;
  }
});
Object.defineProperty(exports, "clearTokens", {
  enumerable: true,
  get: function get() {
    return _tokens.clearTokens;
  }
});
Object.defineProperty(exports, "errorLink", {
  enumerable: true,
  get: function get() {
    return _clientLinks.errorLink;
  }
});
Object.defineProperty(exports, "fetchAccessToken", {
  enumerable: true,
  get: function get() {
    return _tokens.fetchAccessToken;
  }
});
Object.defineProperty(exports, "fetchRefreshTokenEmailPass", {
  enumerable: true,
  get: function get() {
    return _tokens.fetchRefreshTokenEmailPass;
  }
});
Object.defineProperty(exports, "fetchRefreshedRefreshToken", {
  enumerable: true,
  get: function get() {
    return _tokens.fetchRefreshedRefreshToken;
  }
});
Object.defineProperty(exports, "fetchToken", {
  enumerable: true,
  get: function get() {
    return _core.fetchToken;
  }
});
Object.defineProperty(exports, "getAccessToken", {
  enumerable: true,
  get: function get() {
    return _tokens.getAccessToken;
  }
});
Object.defineProperty(exports, "getAccessTokenWithRefreshToken", {
  enumerable: true,
  get: function get() {
    return _fetchers.getAccessTokenWithRefreshToken;
  }
});
Object.defineProperty(exports, "getApolloClient", {
  enumerable: true,
  get: function get() {
    return _getApolloClient["default"];
  }
});
Object.defineProperty(exports, "getAuthType", {
  enumerable: true,
  get: function get() {
    return _authType.getAuthType;
  }
});
Object.defineProperty(exports, "getLocalToken", {
  enumerable: true,
  get: function get() {
    return _core.getLocalToken;
  }
});
Object.defineProperty(exports, "getRefreshToken", {
  enumerable: true,
  get: function get() {
    return _tokens.getRefreshToken;
  }
});
Object.defineProperty(exports, "getRefreshTokenWithEmailPass", {
  enumerable: true,
  get: function get() {
    return _fetchers.getRefreshTokenWithEmailPass;
  }
});
Object.defineProperty(exports, "getTimeUntilExpiration", {
  enumerable: true,
  get: function get() {
    return _core.getTimeUntilExpiration;
  }
});
Object.defineProperty(exports, "graphqlWsLink", {
  enumerable: true,
  get: function get() {
    return _clientLinks.graphqlWsLink;
  }
});
Object.defineProperty(exports, "httpLink", {
  enumerable: true,
  get: function get() {
    return _clientLinks.httpLink;
  }
});
Object.defineProperty(exports, "isSubscription", {
  enumerable: true,
  get: function get() {
    return _clientLinks.isSubscription;
  }
});
Object.defineProperty(exports, "operationTypes", {
  enumerable: true,
  get: function get() {
    return _useOperationSubscription.operationTypes;
  }
});
Object.defineProperty(exports, "persistAccessToken", {
  enumerable: true,
  get: function get() {
    return _tokens.persistAccessToken;
  }
});
Object.defineProperty(exports, "persistRefreshToken", {
  enumerable: true,
  get: function get() {
    return _tokens.persistRefreshToken;
  }
});
Object.defineProperty(exports, "redirectToLogin", {
  enumerable: true,
  get: function get() {
    return _redirectToLogin["default"];
  }
});
Object.defineProperty(exports, "redirectToLoginIfNoAccessToken", {
  enumerable: true,
  get: function get() {
    return _redirectToLoginIfNoAccessToken["default"];
  }
});
Object.defineProperty(exports, "redirectToLoginIfNoRefreshToken", {
  enumerable: true,
  get: function get() {
    return _redirectToLoginIfNoRefreshToken["default"];
  }
});
Object.defineProperty(exports, "redirectToLogout", {
  enumerable: true,
  get: function get() {
    return _redirectToLogout["default"];
  }
});
Object.defineProperty(exports, "redirectToUrlWithRefreshToken", {
  enumerable: true,
  get: function get() {
    return _redirectToUrlWithRefreshToken["default"];
  }
});
Object.defineProperty(exports, "refetchWhenExpires", {
  enumerable: true,
  get: function get() {
    return _core.refetchWhenExpires;
  }
});
Object.defineProperty(exports, "refreshRefreshToken", {
  enumerable: true,
  get: function get() {
    return _fetchers.refreshRefreshToken;
  }
});
Object.defineProperty(exports, "refreshTokenRequiringLink", {
  enumerable: true,
  get: function get() {
    return _clientLinks.refreshTokenRequiringLink;
  }
});
Object.defineProperty(exports, "splitTransportLink", {
  enumerable: true,
  get: function get() {
    return _clientLinks.splitTransportLink;
  }
});
Object.defineProperty(exports, "suspenseQueryTypes", {
  enumerable: true,
  get: function get() {
    return _useSuspenseSubscription.suspenseQueryTypes;
  }
});
Object.defineProperty(exports, "unauthenticatedErrorLink", {
  enumerable: true,
  get: function get() {
    return _clientLinks.unauthenticatedErrorLink;
  }
});
Object.defineProperty(exports, "useImperativeQuery", {
  enumerable: true,
  get: function get() {
    return _useImperativeQuery["default"];
  }
});
Object.defineProperty(exports, "useLoaderStateUpdate", {
  enumerable: true,
  get: function get() {
    return _useLoaderStateUpdate["default"];
  }
});
Object.defineProperty(exports, "useOperationSubscription", {
  enumerable: true,
  get: function get() {
    return _useOperationSubscription["default"];
  }
});
Object.defineProperty(exports, "useSuspenseSubscription", {
  enumerable: true,
  get: function get() {
    return _useSuspenseSubscription["default"];
  }
});
var _core = require("./auth/core");
var _fetchers = require("./auth/fetchers");
var _redirectToLogin = _interopRequireDefault(require("./auth/redirectToLogin"));
var _redirectToLoginIfNoAccessToken = _interopRequireDefault(require("./auth/redirectToLoginIfNoAccessToken"));
var _redirectToLoginIfNoRefreshToken = _interopRequireDefault(require("./auth/redirectToLoginIfNoRefreshToken"));
var _redirectToLogout = _interopRequireDefault(require("./auth/redirectToLogout"));
var _redirectToUrlWithRefreshToken = _interopRequireDefault(require("./auth/redirectToUrlWithRefreshToken"));
var _tokens = require("./auth/tokens");
var _authType = require("./auth/authType");
var _ApolloProvider = _interopRequireDefault(require("./ApolloProvider"));
var _clientLinks = require("./clientLinks");
var _ConnectionStatus = _interopRequireDefault(require("./ConnectionStatus"));
var _getApolloClient = _interopRequireDefault(require("./getApolloClient"));
var _TokenFetchLink = _interopRequireDefault(require("./TokenFetchLink"));
var _useImperativeQuery = _interopRequireDefault(require("./useImperativeQuery"));
var _useLoaderStateUpdate = _interopRequireDefault(require("./useLoaderStateUpdate"));
var _useOperationSubscription = _interopRequireWildcard(require("./useOperationSubscription"));
var _useSuspenseSubscription = _interopRequireWildcard(require("./useSuspenseSubscription"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }